(function () {
  'use strict';

  if (window.PGCompleteSetPolishV5) return;
  window.PGCompleteSetPolishV5 = true;

  var STYLE_ID = 'pg-complete-set-alignment-v5';
  var applyTimer = null;
  var intervalId = null;

  var CSS = [
    '.pg-complete-set--cart .pg-complete-set__card-content{display:flex!important;flex-direction:column!important;align-items:stretch!important;min-width:0!important;height:100%!important;}',
    '.pg-complete-set--cart .pg-complete-set__title-row{width:100%!important;min-height:38px!important;align-items:flex-start!important;}',
    '.pg-complete-set--cart .pg-complete-set__card-note{width:100%!important;min-height:28px!important;}',
    '.pg-complete-set--cart .pg-complete-set__price{width:100%!important;min-height:22px!important;}',
    '.pg-complete-set--cart .pg-complete-set__field{display:block!important;width:100%!important;margin:6px 0 0!important;margin-top:auto!important;}',
    '.pg-complete-set--cart .pg-complete-set__field-label{display:block!important;width:100%!important;margin:0 0 4px!important;}',
    '.pg-complete-set--cart .pg-complete-set__select{display:block!important;width:100%!important;height:34px!important;min-height:34px!important;margin:0!important;padding:5px 30px 5px 10px!important;}',
    '.pg-complete-set--cart .pg-complete-set__button{display:block!important;width:100%!important;min-width:100%!important;min-height:34px!important;margin:6px 0 0!important;margin-top:auto!important;padding:7px 12px!important;border-radius:999px!important;}',
    '.pg-complete-set--cart .pg-complete-set__field+.pg-complete-set__button{grid-column:1/-1!important;width:100%!important;min-width:100%!important;margin-top:6px!important;}',
    '.pg-complete-set--cart .pg-complete-set__card{align-items:stretch!important;}',
    '.cart_content .pg-onward-optout-link,.cart_content [data-pg-onward-optout]{-webkit-appearance:none!important;appearance:none!important;display:block!important;width:max-content!important;max-width:100%!important;min-width:0!important;min-height:0!important;height:auto!important;margin:10px auto 0!important;padding:0!important;background:transparent!important;background-color:transparent!important;background-image:none!important;border:0!important;border-radius:0!important;box-shadow:none!important;color:#1f2a3c!important;font-family:Poppins,sans-serif!important;font-size:13px!important;font-weight:700!important;line-height:1.4!important;letter-spacing:0!important;text-align:center!important;text-decoration:underline!important;text-decoration-thickness:1px!important;text-underline-offset:3px!important;text-transform:none!important;cursor:pointer!important;}'
  ].join('');

  function ensureStyle() {
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      document.head.appendChild(style);
    } else if (style.textContent !== CSS) {
      style.textContent = CSS;
    }
  }

  function textOf(element) {
    return ((element && (element.value || element.getAttribute('aria-label') || element.innerText || element.textContent)) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function important(element, property, value) {
    if (element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') return;
    element.style.setProperty(property, value, 'important');
  }

  function forceTextLink(control) {
    control.classList.add('pg-onward-optout-link');
    control.setAttribute('data-pg-onward-optout', '');

    [
      ['-webkit-appearance', 'none'],
      ['appearance', 'none'],
      ['display', 'block'],
      ['width', 'max-content'],
      ['max-width', '100%'],
      ['min-width', '0'],
      ['min-height', '0'],
      ['height', 'auto'],
      ['margin', '10px auto 0'],
      ['padding', '0'],
      ['background', 'transparent'],
      ['background-color', 'transparent'],
      ['background-image', 'none'],
      ['border', '0'],
      ['border-radius', '0'],
      ['box-shadow', 'none'],
      ['color', '#1f2a3c'],
      ['font-family', 'Poppins, sans-serif'],
      ['font-size', '13px'],
      ['font-weight', '700'],
      ['line-height', '1.4'],
      ['letter-spacing', '0'],
      ['text-align', 'center'],
      ['text-decoration', 'underline'],
      ['text-decoration-thickness', '1px'],
      ['text-underline-offset', '3px'],
      ['text-transform', 'none'],
      ['cursor', 'pointer']
    ].forEach(function (entry) {
      important(control, entry[0], entry[1]);
    });
  }

  function markOnwardOptOut() {
    var drawer = document.querySelector('.cart_content');
    if (!drawer) return;

    drawer.querySelectorAll('a, button, [role="button"], input[type="button"], input[type="submit"]').forEach(function (control) {
      if (!/continue\s+without/.test(textOf(control))) return;
      forceTextLink(control);
    });
  }

  function apply() {
    ensureStyle();
    markOnwardOptOut();
  }

  function scheduleApply(delay) {
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(apply, delay == null ? 0 : delay);
  }

  function schedulePasses() {
    [0, 80, 220, 600, 1200].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  function mutationTouchesDrawer(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
    if (target && (target.matches('.cart_content') || target.closest('.cart_content'))) return true;

    return Array.from(mutation.addedNodes || []).some(function (node) {
      if (!(node instanceof Element)) return false;
      return node.matches('.cart_content') || Boolean(node.querySelector('.cart_content'));
    });
  }

  function init() {
    apply();
    schedulePasses();

    document.addEventListener('cart:refresh', schedulePasses);
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.cart_content')) schedulePasses();
    }, true);

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', schedulePasses);
    }

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        if (mutations.some(mutationTouchesDrawer)) scheduleApply(20);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('pagehide', function () {
      if (intervalId) window.clearInterval(intervalId);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
